import React, { Component } from 'react';
import { firebaseAuth, logComponentLoad, logDashboardAction } from '../../../../config/constants'
import { Grid, Divider, Button, Form, Segment } from 'semantic-ui-react';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


export default class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 0,
            email: '',
            algoliaUser: ''
        }
    }

    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    // this.getApiDetails();
                    //getShirtTypes(this.loadShirtTypes);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        //console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        logComponentLoad(returnObject, "PasswordReset");
        logDashboardAction(returnObject.algoliaUser.key + " loaded password_reset", returnObject.algoliaUser.key, null, "PasswordReset");

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("password_reset")) {

        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    check_email = (email) => {
        console.log("++++++ check_email:" + email);
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailReg.test(email);

    }

    resetPassword = () => {
        console.log("++++++ resetPassword:" + this.state.email);

        let admin_email = this.state.user.email;
        let fixed_email = this.state.email;

        if (this.check_email(this.state.email)) {
            console.log("email is valid:" + this.state.email);

            firebaseAuth().sendPasswordResetEmail(this.state.email).then(function () {
                alert("password reset email sent if email exists in system:" + fixed_email);

                logDashboardAction(admin_email + " password_reset for " + fixed_email, admin_email, null, "PasswordReset");

            }).catch(function (error) {
                logDashboardAction(admin_email + " FAILED password_reset for " + fixed_email+" "+error, admin_email, null, "PasswordReset");
                alert("An error occurred:" + error);
            });


        } else {
            console.log("invalid email...");
            alert("invalid email, pls double check");
        }

    }


    render() {

        const uploadButton = this.state.email != ''
            ? <Button color='red' onClick={this.uploadDocument}>SEND PASSWORD RESET EMAIL</Button>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("password_reset")
            ? <div>
                <Divider horizontal>{'UPLOAD DOCUMENT'}</Divider>

                <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'
                >
                    <Grid.Column style={{ maxWidth: 450 }}>

                        <Form size='large' onSubmit={this.resetPassword}>
                            <Segment stacked>
                                <label> RESET PASSWORD </label>
                                <Form.Input
                                    fluid
                                    icon='mail'
                                    iconPosition='left'
                                    placeholder='email address'
                                    type='email'
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.handleTextInputChange}
                                />

                                {uploadButton}
                            </Segment>
                        </Form>
                    </Grid.Column>
                </Grid>


                <br />

            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}


            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/PasswordReset/PasswordReset.js